import React, { Fragment } from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './bluetooth.css'

const Bluetooth = (props) => {
  return (
    <div className="bluetooth-container1">
      <Helmet>
        <title>
          Bluetooth - GESVET – App para digitalizar el trabajo veterinario en
          campo
        </title>
        <meta
          name="description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:title"
          content="Bluetooth - GESVET – App para digitalizar el trabajo veterinario en campo"
        />
        <meta
          property="og:description"
          content="Solución móvil para veterinarios de ganado bovino. Registro de animales, estadísticas de preñez, revisación de toros e informes profesionales."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/c5d5ed29-b3ec-4d24-824a-945896b13c65/a683aef5-7460-454d-aed7-588f9c14e5a7?org_if_sml=1&amp;force_format=original"
        />
        <link rel="canonical" href="https://www.gesvet.com.ar/bluetooth" />
        <meta property="og:url" content="https://www.gesvet.com.ar/bluetooth" />
      </Helmet>
      <Navigation rootClassName="navigationroot-class-name1"></Navigation>
      <section className="bluetooth-thq-hero-section-elm hero-section">
        <img
          alt="image"
          src="/images/tranquera-1500h.jpg"
          className="bluetooth-image1 hero-bg"
        />
        <div className="bluetooth-thq-hero-content-wrapper-elm hero-content-wrapper">
          <div className="hero-badge">
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                d="m7 7l10 10l-5 5V2l5 5L7 17"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
            <span>Conectividad Total</span>
          </div>
          <h1 className="bluetooth-thq-hero-title-elm bluetooth-dispositivos-hero-title hero-title">
            Bluetooth y Dispositivos
          </h1>
          <p className="hero-subtitle">
            Integramos la lectura de caravanas electrónicas directamente en tu
            flujo de trabajo. Compatible con todos los dispositivos del mercado.
          </p>
          <div className="bluetooth-thq-hero-cta-group-elm bluetooth-dispositivos-hero-cta-group"></div>
        </div>
      </section>
      <section className="compatibility-banner">
        <div className="banner-content">
          <div className="banner-icon">
            <svg
              width="24"
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 0 24 24"
            >
              <g
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M3.85 8.62a4 4 0 0 1 4.78-4.77a4 4 0 0 1 6.74 0a4 4 0 0 1 4.78 4.78a4 4 0 0 1 0 6.74a4 4 0 0 1-4.77 4.78a4 4 0 0 1-6.75 0a4 4 0 0 1-4.78-4.77a4 4 0 0 1 0-6.76"></path>
                <path d="m9 12l2 2l4-4"></path>
              </g>
            </svg>
          </div>
          <h2 className="section-title">
            Compatible con todos los dispositivos del mercado
          </h2>
        </div>
      </section>
      <section id="devices" className="devices-grid">
        <div className="grid-container">
          <div className="device-card">
            <img
              alt="image"
              src="/images/bastones/gallagher1600x1600-1500w.jpg"
              className="bluetooth-image2 device-image"
            />
            <div className="device-header">
              <span className="device-brand">Gallagher</span>
              <h3>HR4 - HR5</h3>
            </div>
            <p className="section-content">
              Lectura de alta performance para trabajos intensivos en manga.
            </p>
            <ul className="device-specs">
              <li>
                <span>Vincular vía Bluetooth</span>
              </li>
              <li>
                <span>Confirmar código de emparejamiento</span>
              </li>
            </ul>
          </div>
          <div className="device-card">
            <img
              alt="image"
              src="/images/bastones/true-test1074x1074-1500w.jpg"
              className="bluetooth-image3 device-image"
            />
            <div className="device-header">
              <span className="device-brand">True Test</span>
              <h3>XRS2</h3>
            </div>
            <p className="section-content">
              Versatilidad y precisión en la captura de datos electrónicos.
            </p>
            <ul className="device-specs">
              <li>
                <span>Modo de conexión HID</span>
              </li>
              <li>
                <span>Configuración Teclado Externo</span>
              </li>
            </ul>
          </div>
          <div className="device-card">
            <img
              alt="image"
              src="/images/bastones/syno%201200x1200-200h.jpg"
              className="bluetooth-image4 device-image"
            />
            <div className="device-header">
              <span className="device-brand">Syno</span>
              <h3>Syno Reader</h3>
            </div>
            <p className="section-content">
              Simplicidad y eficiencia para el registro rápido de caravanas.
            </p>
            <ul className="device-specs">
              <li>
                <span>Modo Puerto Serie BT (SPP)</span>
              </li>
              <li>
                <span>Conexión estable a campo</span>
              </li>
            </ul>
          </div>
          <div className="device-card">
            <img
              alt="image"
              src="/images/bastones/allflex%201068x1068-1500w.jpg"
              className="bluetooth-image5 device-image"
            />
            <div className="device-header">
              <span className="device-brand">AllFlex</span>
              <h3>AllFlex Stick</h3>
            </div>
            <p className="section-content">
              El estándar de la industria para identificación animal.
            </p>
            <ul className="device-specs">
              <li>
                <span>Modo Slave (Esclavo)</span>
              </li>
              <li>
                <span>Código de emparejamiento: 0000</span>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section id="config-guide" className="config-section">
        <div className="config-container">
          <div className="config-header">
            <h2 className="section-title">Guía de Configuración</h2>
            <p className="section-subtitle">
              Sigue estos 3 pasos para conectar tu bastón lector
            </p>
          </div>
          <div className="steps-wrapper">
            <div className="bluetooth-dispositivos-step-item">
              <div className="bluetooth-dispositivos-step-number">
                <span>1</span>
              </div>
              <div className="step-content">
                <h3>Vincular Dispositivo</h3>
                <p className="section-content">
                  Ingresa a los ajustes de Bluetooth de tu dispositivo Android
                  (Tablet o Celular) y busca tu bastón lector en la lista de
                  dispositivos disponibles.
                </p>
              </div>
            </div>
            <div className="bluetooth-dispositivos-step-item">
              <div className="bluetooth-dispositivos-step-number">
                <span>2</span>
              </div>
              <div className="step-content">
                <h3>Configurar Modo</h3>
                <p className="section-content">
                  Asegúrate de que el bastón esté en el modo Bluetooth SPP.
                </p>
              </div>
            </div>
            <div className="bluetooth-dispositivos-step-item">
              <div className="bluetooth-dispositivos-step-number">
                <span>3</span>
              </div>
              <div className="step-content">
                <h3>Activar en GESVET</h3>
                <p className="section-content">
                  Dentro de la App, presiona el ícono de Bluetooth. Si está en
                  verde, estás listo para leer. Si está en rojo, selecciona tu
                  bastón del listado.
                </p>
              </div>
            </div>
          </div>
          <div className="permissions-box">
            <div className="permission-icon">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <g
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12"></circle>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3m.08 4h.01"></path>
                </g>
              </svg>
            </div>
            <div className="permission-text">
              <strong>¿Problemas de conexión?</strong>
              <p className="section-content">
                Verifica los permisos: Información de la App → Permisos →
                Dispositivos cercanos → Permitir.
              </p>
            </div>
          </div>
        </div>
      </section>
      <div className="bluetooth-container2">
        <div className="bluetooth-container3">
          <Script
            html={`<script>
(function(){
  // Mobile Menu Toggle
  const mobileBtn = document.getElementById("mobileMenuBtn")
  const navLinks = document.querySelector(".nav-links")

  if (mobileBtn) {
    mobileBtn.addEventListener("click", () => {
      const isVisible = navLinks.style.display === "flex"
      navLinks.style.display = isVisible ? "none" : "flex"

      if (!isVisible) {
        navLinks.style.position = "absolute"
        navLinks.style.top = "100%"
        navLinks.style.left = "0"
        navLinks.style.width = "100%"
        navLinks.style.flexDirection = "column"
        navLinks.style.padding = "var(--spacing-xl)"
        navLinks.style.backgroundColor = "var(--color-surface)"
        navLinks.style.borderBottom = "var(--divider-value)"
        navLinks.style.zIndex = "99"
      }
    })
  }

  // Scroll reveal animation for cards
  const cards = document.querySelectorAll(".device-card")
  const revealOnScroll = () => {
    cards.forEach((card) => {
      const cardTop = card.getBoundingClientRect().top
      const windowHeight = window.innerHeight
      if (cardTop < windowHeight * 0.85) {
        card.style.opacity = "1"
        card.style.transform = "translateY(0)"
      }
    })
  }

  // Initial setup for cards
  cards.forEach((card) => {
    card.style.opacity = "0"
    card.style.transform = "translateY(30px)"
    card.style.transition = "all 0.6s ease-out"
  })

  window.addEventListener("scroll", revealOnScroll)
  revealOnScroll() // Run once on load
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer
        text={
          <Fragment>
            <span className="bluetooth-text30">Soporte</span>
          </Fragment>
        }
        text1={
          <Fragment>
            <span className="bluetooth-text31">Aplicacion</span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="bluetooth-text32">Home</span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="bluetooth-text33">Bluetooth</span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="bluetooth-text34">Soporte1</span>
          </Fragment>
        }
        rootClassName="footerroot-class-name"
      ></Footer>
    </div>
  )
}

export default Bluetooth
